import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { Router } from '@angular/router';
import { User } from 'app/shared/models/User';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

    headerTitle: IHeaderTitle;
    errors: string[];
    userUrl: Router;
    user: User;

    constructor(
        private sharedService: SharedService
    ) {
    }

    ngOnInit() {
        this.sharedService.currentUser.subscribe(user => { this.user = user });
        this.headerTitle = { title: 'Administration' }
    }

}
